import PropTypes from 'prop-types';
import { useDraggable } from '@dnd-kit/core';

/**
 * Wrapper component for dnd-kit's useDraggable to provide a similar API to react-beautiful-dnd's Draggable
 * @component
 */
const Draggable = ({ children, draggableId, index, isDragDisabled = false }) => {
	const {
		attributes,
		listeners,
		setNodeRef,
		transform: _transform,
		isDragging,
	} = useDraggable({
		id: draggableId,
		disabled: isDragDisabled,
		data: {
			index,
			droppableId: 'collection', // Default droppable ID - will be overridden by actual implementation
		},
	});

	const style = {
		// Don't apply transform to keep original item in place while dragging a copy
		transform: 'none',
		opacity: 1,
	};

	// Create a snapshot object similar to react-beautiful-dnd
	const snapshot = {
		isDragging,
		isDropAnimating: false, // dnd-kit doesn't provide this directly
		isClone: false,
		draggingOver: null, // dnd-kit doesn't provide this directly
		dropAnimation: null,
		mode: null,
	};

	// Create a provided object similar to react-beautiful-dnd
	const provided = {
		innerRef: setNodeRef,
		draggableProps: {
			...attributes,
			style,
		},
		dragHandleProps: {
			...listeners,
		},
	};

	return children(provided, snapshot);
};

Draggable.propTypes = {
	children: PropTypes.func.isRequired,
	draggableId: PropTypes.string.isRequired,
	index: PropTypes.number.isRequired,
	isDragDisabled: PropTypes.bool,
};

export default Draggable;
